import { Component, input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrl: './image.component.scss',
})
export class ImageComponent implements OnInit {
  fileSrc = input.required<string>();
  fileAlt = input.required<string>();
  newFileSrc = '';

  ngOnInit(): void {
    this.newFileSrc = this.fileSrc();
  }

  onError(): void {
    if (this.newFileSrc.includes('.svg')) {
      this.newFileSrc = this.newFileSrc.replace('.svg', '.png');
    } else if (this.newFileSrc.includes('.png')) {
      this.newFileSrc = this.newFileSrc.replace('.png', '.jpg');
    }
  }
}
